
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMosfetNtype2 as ObiMosfetNtype2Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-mosfet-ntype-2.js';
 
 
 

 
 export const ObiMosfetNtype2 = createComponent({
   react: React,
   tagName: 'obi-mosfet-ntype-2',
   elementClass: ObiMosfetNtype2Element,
   events: {
     
   }
  });
 
 